// extracted by mini-css-extract-plugin
export default {"m":"b77b06e39a","title":"_061bd71aa5","feedback_inner_title":"_3a8f70b3f7","textarea":"f9cf591c83","radio":"_7c2cf94cad","text":"_6af1dc419e"};